/**
 * @generated SignedSource<<ab845ea062dcf8aa409dbe49e2cdfa97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InvitePersonsToTeamInput = {
  clientMutationId?: string | null;
  orgRelayId: string;
  personIds: ReadonlyArray<string>;
  teamId: string;
};
export type InvitePersonsToTeamMutation$variables = {
  input: InvitePersonsToTeamInput;
};
export type InvitePersonsToTeamMutation$data = {
  readonly invitePersonsToTeam: {
    readonly clientMutationId: string | null;
  } | null;
};
export type InvitePersonsToTeamMutation = {
  variables: InvitePersonsToTeamMutation$variables;
  response: InvitePersonsToTeamMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InvitePersonsToTeamPayload",
    "kind": "LinkedField",
    "name": "invitePersonsToTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InvitePersonsToTeamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InvitePersonsToTeamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "62fc3c096de554c02cbf97d3afa1b23d",
    "id": null,
    "metadata": {},
    "name": "InvitePersonsToTeamMutation",
    "operationKind": "mutation",
    "text": "mutation InvitePersonsToTeamMutation(\n  $input: InvitePersonsToTeamInput!\n) {\n  invitePersonsToTeam(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff844cb280f6183d0e2c561b5c62ee42";

export default node;
